import type { TypographyV3Element } from '@jouzen/ecom-components';
import { TypographyV3 } from '@jouzen/ecom-components';
import { cx } from 'class-variance-authority';
import { type PropsWithChildren } from 'react';

export interface PopBottomEyebrowProps extends PropsWithChildren {
  readonly className?: string;
  readonly Element: TypographyV3Element;
}

const PopBottomEyebrow = ({
  className,
  children,
  Element,
}: PopBottomEyebrowProps) => {
  return (
    <TypographyV3
      className={cx('text-sm tracking-wider uppercase lg:text-base', className)}
      color="inherit"
      Element={Element}
      weight="bold"
    >
      {children}
    </TypographyV3>
  );
};

export default PopBottomEyebrow;
